import { useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { partnersAlerts, useAlert } from 'shared/components/alerts';
import { useDialog } from 'ogp/providers/dialog-provider';
import { QUERY_KEYS } from 'api/query-keys';
import { useArchivePartner } from './use-archive-partner';
import { routes } from '../../../../../Routes';
import { useHqRelativePath } from '../../../../hooks/useHqRelativePath';

const useArchivePartnerDialog = () => {
  const generatePath = useHqRelativePath();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { t } = useTranslation(['hq-screen-specific', 'web-common']);
  const { alertSuccess, alertError } = useAlert();
  const archivePartner = useArchivePartner();
  const { openDialog, closeDialog, enableDialog, disableDialog } = useDialog();

  const archivePartnerDialog = (id: string) => {
    openDialog(
      {
        title: t('partners.dialogs.archive_partner.title', { ns: 'hq-screen-specific' }),
      },
      () => {
        disableDialog();
        archivePartner.mutate(id, {
          onSuccess: () => {
            closeDialog();
            queryClient.invalidateQueries(QUERY_KEYS.partners());
            alertSuccess(partnersAlerts.success.archived);
            navigate(generatePath(routes.Partners));
          },
          onError: (e) => alertError(e),
          onSettled: () => enableDialog(),
        });
      }
    );
  };

  return { open: archivePartnerDialog };
};

export { useArchivePartnerDialog };
